import { render, staticRenderFns } from "./distribution4.vue?vue&type=template&id=73db03d7&scoped=true"
import script from "./distribution4.vue?vue&type=script&lang=js"
export * from "./distribution4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73db03d7",
  null
  
)

export default component.exports